import { Reveal } from "../site/Reveal";
import { BrainCircuit, Clock, FileSearch, Lock } from "lucide-react";
import { useT } from "@/i18n/useLocale";

const ICONS = [BrainCircuit, Clock, FileSearch, Lock];

export function SeguridadFacturas() {
  const t = useT();
  const s = t.facturas.seguridad;

  return (
    <section id="seguridad" className="border-t border-hairline bg-surface py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="mb-3 text-xs uppercase tracking-[0.18em] text-ink-soft/70">{s.eyebrow}</p>
          <h2 className="font-display max-w-3xl text-4xl leading-[1.05] tracking-tight text-ink sm:text-5xl">
            {s.title}
          </h2>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-soft">{s.intro}</p>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2">
          {s.items.map((it, i) => {
            const Icon = ICONS[i] ?? Lock;
            return (
              <Reveal key={it.v} delay={i * 0.06}>
                <div className="flex h-full gap-5 rounded-2xl border border-hairline bg-background p-7">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <h3 className="font-display text-lg leading-tight tracking-tight text-ink">{it.v}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-ink-soft">{it.l}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
